<script>
  import DropDown from './DropDown.svelte';
  import Select from 'svelte-select';
  import FormInput from 'components/FormControls/FormInput.svelte';
  import { customInputEvent, searchKeyByValue, numberOnly, configItem } from 'components/Helper.js';
  const recurringTypes = configItem.recurringTypes;
  const customRecurringTypes = configItem.customRecurringTypes;

  export let form;
  export let errors;
  export let handleChange;
  export let disabledAllFields = false;

  let selectedRecurringType;
  if ($form.id > 0 && $form.recurringCustom == 1 && $form.recurringType > 0) {
    selectedRecurringType =
      customRecurringTypes[searchKeyByValue(customRecurringTypes, 'id', $form.recurringType)];
  }
</script>

<div class="col-md-12">
  <div class="row">
    <div class="col-mt-6">
      <label
        for=""
        class="text-nowrap form-label">Repeat Every</label
      >
      <div class="d-flex flex-row">
        <div class="">
          <div class="me-2">
            <FormInput
              disabled={disabledAllFields}
              inputStyle="recuring-every-input"
              name="recurringEvery"
              keypress={(e) => numberOnly(e)}
              label=""
              type="number"
              max="50"
              placeholder="Every"
              handleChange={handleChange}
              error={$errors.recurringEvery}
              bind:value={$form.recurringEvery}
            />
          </div>
        </div>

        <div class="col-md-3">
          <div
            class="form-group mb-3 select-block select-client-type d-flex flex-column position-relative {$errors.recurringType
              ? 'error'
              : ''}"
          >
            <Select
              isDisabled={disabledAllFields}
              bind:selectedValue={selectedRecurringType}
              items={customRecurringTypes}
              name="recurringType"
              placeholder="Select Recurring Type"
              showChevron={true}
              isClearable={true}
              getSelectionLabel={(option) => {
                return option.name;
              }}
              containerClasses="form-control"
              on:select={(ev) => {
                $form.recurringType = ev.detail.id;
                handleChange(customInputEvent('recurringType', ev.detail.id));
              }}
              optionIdentifier="id"
              getOptionLabel={(option) => {
                return option.name;
              }}
            ></Select>
            {#if $errors.recurringType}
              <label
                for=""
                class="formError"
              >
                {$errors.recurringType}
              </label>
            {/if}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-8">
		  <div class="d-flex flex-column">
				<label for="" class="text-nowrap form-label ">Repeat On: </label>
				<div>
				  <button class="rounded-circle background-blue btn-alarm">
					<span class="text-white">S</span>
				  </button>

				  <button class="rounded-circle btn-alarm bg-transparent">
					<span class="text-black">M</span>
				  </button>

				  <button class="rounded-circle btn-alarm bg-transparent">
					<span class="text-black">T</span>
				  </button>

				  <button class="rounded-circle btn-alarm bg-transparent">
					<span class="text-black">W</span>
				  </button>

				  <button class="rounded-circle btn-alarm bg-transparent">
					<span class="text-black">T</span>
				  </button>

				  <button class="rounded-circle btn-alarm bg-transparent">
					<span class="text-black">F</span>
				  </button>

				  <button class="rounded-circle btn-alarm bg-transparent">
					<span class="text-black">S</span>
				  </button>
				</div>
			</div>
	  </div> -->
  </div>
</div>
